class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.sideCart = document.querySelector("side-cart");
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartNotification = document.querySelector('cart-notification');
    
    // Pre-Order button handler - use event delegation since button may be added dynamically
    this.addEventListener('click', (evt) => {
      const preOrderButton = evt.target.closest('.product-form__preorder-submit');
      if (preOrderButton) {
        evt.preventDefault();
        evt.stopPropagation();
        this.onPreOrderHandler(evt, preOrderButton);
      }
    });
  }

  shouldShowSizeError(submitButton) {
    // Verify directly if non-color options are selected in the DOM
    // This is more reliable than checking disable-select-size class
    // because that class can be set when add to cart button is hidden due to no stock
    const sizeFieldsets = document.querySelectorAll('variant-radios fieldset:not([data-option-name="Color"]):not([data-option-name="color"])');
    
    if (sizeFieldsets.length > 0) {
      // Check if all size-related fieldsets have a selected option
      for (let fieldset of sizeFieldsets) {
        const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
        if (!checkedInput || !checkedInput.value) {
          return true; // Size not selected
        }
      }
      return false; // All sizes selected
    }
    
    // Fallback: if no fieldsets found, check the disable-select-size class
    // This handles other product types (like selects or gift cards)
    if (submitButton && submitButton.classList.contains('disable-select-size')) {
      return true;
    }
    
    return false; // No size selection required or all selected
  }

  async onSubmitHandler(evt) {
    evt.preventDefault();
    if(!this.sideCart) this.cartNotification.setActiveElement(document.activeElement);

    const submitButton = this.querySelector('[type="submit"]');

    if(this.form.parentElement.classList.contains('giftcard-form')) {
      var breakFlag = 0;
      const giftProperties = this.form.querySelectorAll('.required-entry.input-text');
      if(giftProperties.length) {
        giftProperties.forEach(giftRequiredItem => {
          if(giftRequiredItem.value) {
            giftRequiredItem.classList.remove("alert");
            breakFlag++;
          } else {
            giftRequiredItem.classList.add("alert");
          }
        });
        if(breakFlag != giftProperties.length) {
          return;
        }
      }
    }

    if(submitButton.classList.contains('disable-select-size')) {
      if(this.form.parentElement.classList.contains('giftcard-form')) {
        var checkFlag = true;
        const variantItems = document.querySelectorAll('.gift-card__variants');
        if(variantItems.length) {
          for(var i = 0; i < variantItems.length; i++) {
            if(variantItems[i].querySelectorAll("input:checked").length == 0) {
              checkFlag = false;
              break;
            }
          }
        }
        if(!checkFlag) {
          submitButton.previousElementSibling.style.display = 'block';  
        }
      } else {
        submitButton.previousElementSibling.style.display = 'block';
      }
      document.querySelectorAll('variant-radios fieldset:not([data-option-name="Color"])').forEach((fieldset) => {
        fieldset.classList.add('no-select');
        setTimeout(() =>  fieldset.classList.remove('no-select'),1000);
      })
      return;
    }
    // if(document.querySelector('variant-radios fieldset:not([data-option-name="Color"])').querySelectorAll('input[type="radio"]:checked').length == 0) {
        
    //   return;
    // }
    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    const properties = {
      ...fetchConfig('javascript'),
      body
    }

    if(this.sideCart) {
      // only pass the body json, since we are using different fetch endpoint for sidecart
      // right now body is in string, so convert it to JSON object, and pass the needed variables
      const itemJson = JSON.parse(body);
      const itemProps = {};

      for (const key in itemJson) {
        if(key.includes('properties')) {
          const propsName = key.replace('properties[', '').replace(']', '');
          itemProps[propsName] = itemJson[key];
        }
      }
      const addToCartSuccess = await this.sideCart.addToCart(itemJson.id,1,itemProps);
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('disabled');
      
      if (addToCartSuccess) {
        this.sideCart.openCart();
      }
    }
    else {
      fetch(`${routes.cart_add_url}`, properties)
        .then((response) => response.json())
        .then((parsedState) => {
          this.cartNotification.renderContents(parsedState);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        });
    }
  }

  async onPreOrderHandler(evt, preOrderButton) {
    // Get the button element if not passed as parameter
    if (!preOrderButton) {
      preOrderButton = evt.target.closest('.product-form__preorder-submit');
    }
    
    if (!preOrderButton) {
      return;
    }
    
    // Validate that sizes are selected (same logic as add to cart button)
    const submitButton = this.querySelector('[type="submit"]');
    
    // Always hide the error message first (in case it was shown previously)
    if (submitButton && submitButton.previousElementSibling) {
      submitButton.previousElementSibling.style.display = 'none';
    }
    
    // Use same validation as add to cart: check disable-select-size class + DOM verification
    if (this.shouldShowSizeError(submitButton)) {
      // Show error message (same as add to cart)
      if (submitButton && submitButton.previousElementSibling) {
        submitButton.previousElementSibling.style.display = 'block';
      }
      // Add visual feedback to size selection (same as add to cart)
      document.querySelectorAll('variant-radios fieldset:not([data-option-name="Color"])').forEach((fieldset) => {
        fieldset.classList.add('no-select');
        setTimeout(() =>  fieldset.classList.remove('no-select'),1000);
      });
      return;
    }

    // If a color change is mid-flight, the dataset.preOrderVariantId still points to the
    // previous color's variant. Wait for the new pre-order product to finish loading, then
    // resolve the variant from the up-to-date preOrderProduct instead of the stale dataset.
    const variantRadios = document.querySelector('variant-radios');
    if (variantRadios && variantRadios.preOrderLoadingPromise) {
      preOrderButton.setAttribute('disabled', true);
      preOrderButton.classList.add('loading');
      try { await variantRadios.preOrderLoadingPromise; } catch (e) {}
      preOrderButton.classList.remove('loading');
      preOrderButton.removeAttribute('disabled');
    }

    let preOrderVariantId = null;
    if (variantRadios && typeof variantRadios.findMatchingPreOrderVariant === 'function') {
      const recomputed = variantRadios.findMatchingPreOrderVariant();
      if (recomputed && recomputed.available) {
        preOrderVariantId = recomputed.id;
      }
    }
    if (!preOrderVariantId) {
      preOrderVariantId = preOrderButton.dataset.preOrderVariantId;
    }

    if (!preOrderVariantId) {
      return;
    }

    if(!this.sideCart) this.cartNotification.setActiveElement(document.activeElement);

    preOrderButton.setAttribute('disabled', true);
    preOrderButton.classList.add('loading');

    // Get quantity from form
    const quantityInput = this.form.querySelector('input[name="quantity"]');
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

    // Get preorder message from the button date element
    const preorderDateElement = preOrderButton.querySelector('.preorder-button-date');
    let preorderMessage = ""; // Default fallback

    if (preOrderButton.dataset.preorderShipDate) {
      // Canonical date set by renderPreorderButtonContent (global.js). The visible
      // date-line copy varies per Intelligems test version, so prefer this attribute.
      preorderMessage = `Estimated to Ship ${preOrderButton.dataset.preorderShipDate}`;
    } else if (preorderDateElement && preorderDateElement.textContent) {
      // Extract date from "Wait & Save: Estimated to Ship Feb 15" format
      const dateText = preorderDateElement.textContent;
      const dateMatch = dateText.match(/Estimated to Ship (.+)/);
      if (dateMatch) {
        preorderMessage = `Estimated to Ship ${dateMatch[1]}`;
      } else if (dateText.trim()) {
        // If format is different, use the text directly
        preorderMessage = dateText.trim();
      }
    } else if (window.theme?.pre_order_date) {
      // Fallback: format date from window.theme.pre_order_date
      const dateString = window.theme.pre_order_date;
      const date = new Date(dateString + 'T00:00:00');
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const month = months[date.getMonth()];
      const day = date.getDate();
      preorderMessage = `Estimated to Ship ${month} ${day}`;
    }

    let originalPrice = '00.00';
    if (variantRadios && variantRadios.currentVariant) {
      const priceInCents = variantRadios.currentVariant.compare_at_price || variantRadios.currentVariant.price;
      if (priceInCents) {
        originalPrice = (priceInCents / 100).toFixed(2);
      }
    }

    // Prepare Pre-Order properties
    const preOrderProps = { 
      "Pre-Order": preorderMessage,
      _original_price: originalPrice,
    };

    // Copy other properties from form if they exist (like _final_sale)
    const formData = new FormData(this.form);
    for (const [key, value] of formData.entries()) {
      if (key.startsWith('properties[') && key !== 'properties[Pre-Order]') {
        const propName = key.replace('properties[', '').replace(']', '');
        preOrderProps[propName] = value;
      }
    }

    if(this.sideCart) {
      const addToCartSuccess = await this.sideCart.addToCart(
        parseInt(preOrderVariantId),
        quantity,
        preOrderProps
      );
      
      preOrderButton.classList.remove('loading');
      preOrderButton.removeAttribute('disabled');
      
      if (addToCartSuccess) {
        this.sideCart.openCart();
      }
    } else {
      // Use standard cart add endpoint
      const updates = {
        items: [{
          id: parseInt(preOrderVariantId),
          quantity: quantity,
          properties: preOrderProps
        }]
      };

      const properties = {
        ...fetchConfig('javascript'),
        body: JSON.stringify(updates)
      };

      fetch(`${routes.cart_add_url}`, properties)
        .then((response) => response.json())
        .then((parsedState) => {
          this.cartNotification.renderContents(parsedState);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          preOrderButton.classList.remove('loading');
          preOrderButton.removeAttribute('disabled');
        });
    }
  }
}

customElements.define('product-form', ProductForm);
